import React from 'react';

const TermsOfServiceAcceptance = () => (
  <p>
    By using this website you are agreeing to our{' '}
    <a
      className="link"
      href="https://kassellabs.io/terms"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms of Service
    </a>.
  </p>
);

export default TermsOfServiceAcceptance;
